import { Clients, useMutation } from "../apollo";
import { UpdateUserMutation } from "../graphql/mutations/updateUser";

export const useUpdateUser = () => useMutation(Clients.UPS, UpdateUserMutation);
